import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "../../helpers/withRouter"
import {} from "../../store/actions"
import footerlogo from "../../assets/images/vertace-white.png"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

class Sidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <React.Fragment>
        <div className="vertical-menu">
          <div data-simplebar className="h-80">
            {this.props.type !== "condensed" ? (
              <div>
                <SidebarContent />
                <div className="menufooter text-sm-center text-white">
                  Powered by{" "}
                  <a
                    style={{
                      cursor: "pointer",
                    }}
                    href="https://vertace.com/"
                    target="blank"
                  >
                    <img
                      alt="vertace"
                      src={footerlogo}
                      style={{ width: "80px", objectFit: "contain" }}
                    />
                  </a>
                </div>
              </div>
            ) : (
              <div>
                <SidebarContent />
                <div className="ms-2 menufooter text-white">
                  <a
                    style={{
                      cursor: "pointer",
                      color: "#007bff",
                      textDecoration: "underline",
                    }}
                    href="https://vertace.com/"
                    target="blank"
                  >
                    <img
                      alt="vertace"
                      src={footerlogo}
                      style={{ width: "25px", objectFit: "contain" }}
                    />
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
